import Model from '@/models/Model'

export default class PosCashDesk extends Model {
  get name_case() {
  	return `${this.number} - ${this.name}`
  }
  resource() {
    return 'pos_cash_desk'
  }
}